<i18n>
{
  "en": {
    "optimizer": "Optimizer",
    "manualConfig": "Manual config",
    "menuEditor": "Menu editor",
    "reporting": "Reporting",
    "masters": "Master data"
  },
  "es": {
    "optimizer": "Optimizador",
    "manualConfig": "Configuración manual",
    "menuEditor": "Editor de menú",
    "reporting": "Informes",
    "masters": "Gestión de maestros"
  }
}
</i18n>

<template>
  <div>
    <v-layout row wrap justify-space-around class="pb-6">
      <dynameat-management-button v-for="button in buttonList" :key="button.action"
                                  action="handleAction" :title="button.title"
                                  :icon="button.icon" :show-badge="button.showBadge"
                                  :disabled="button.disabled" v-on="$listeners"
                                  :actionParams="button.routeInfo.name"
                                  class="btn danger dynameatManagementButton">
      </dynameat-management-button>
    </v-layout>
  </div>
</template>

<script>
import Vue from 'vue';
import { PermissionController } from '@core/permissions';
import DynameatManagementButton from '@dynameat/components/DynameatManagementButton';
import Component from 'vue-class-component';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import { MODULES_SETTINGS } from '@dynameat/constants';
import { PredictionPeriod } from '../../../models';

const PERIOD_DEPENDENCY = 'period';

Component.registerHooks(['beforeRouteEnter']);

@Component
@Components({ DynameatManagementButton })
@MapActions(['addNotification'])
@MapGetters(['predictionPeriodList', 'pointOfSaleSettings'])
export default class RestaurantManagementPanel extends Vue {
  @Prop({ Object, validator: ((section) => section instanceof PredictionPeriod) }) nextPeriod;

  get buttonList() {
    const routes = [
      {
        disabled: !this.hasValidDependencies([PERIOD_DEPENDENCY]),
        title: MODULES_SETTINGS.optimizer.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.optimizer.icon,
        showBadge: false,
        routeInfo: { name: 'optimizer' }
      },
      {
        disabled: false,
        title: MODULES_SETTINGS.optimizerPro.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.optimizerPro.icon,
        showBadge: false,
        routeInfo: { name: 'optimizer-pro' }
      },
      {
        disabled: false,
        title: MODULES_SETTINGS.manualConfig.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.manualConfig.icon,
        showBadge: false,
        routeInfo: { name: 'manualConfig' }
      },
      {
        disabled: false,
        title: MODULES_SETTINGS.menuEditor.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.menuEditor.icon,
        showBadge: false,
        routeInfo: { name: 'menuList' }
      },
      {
        disabled: false,
        title: MODULES_SETTINGS.reporting.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.reporting.icon,
        showBadge: false,
        routeInfo: { name: 'reporting' }
      },
      {
        disabled: false,
        title: MODULES_SETTINGS.masters.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.masters.icon,
        showBadge: false,
        routeInfo: { name: 'masters' }
      },
      {
        disabled: false,
        title: MODULES_SETTINGS.powerBiReporting.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.powerBiReporting.icon,
        showBadge: false,
        routeInfo: { name: 'power-bi-reporting' }
      }
    ];
    return routes.filter((route) => PermissionController.getInstance().isAllowed(route.routeInfo.name));
  }

  hasValidDependencies(dependencyArr = []) {
    let valid = true;
    if (dependencyArr.includes(PERIOD_DEPENDENCY)) valid = valid && (this.predictionPeriodList.length > 0 || this.predictionPeriodList.cleared);
    return valid;
  }
}
</script>

<style>
.dynameatManagementButton {
  min-width: 100px;
}
</style>
